export default __webpack_public_path__ + "static/media/SmartBandhan_Bottom_watch.0e74b635.png";